import { useMemo, useState } from 'react';

export const useSortableData = (items, initialConfig = { key: 'paymentDate', direction: 'asc' }) => {
  const [sortConfig, setSortConfig] = useState(initialConfig);

  const sortedItems = useMemo(() => {
    const sortableItems = [...items];
    sortableItems.sort((a, b) => {
      const dateA = new Date(a.paymentDate);
      const dateB = new Date(b.paymentDate);
      return sortConfig.direction === 'asc' ? dateA - dateB : dateB - dateA;
    });
    return sortableItems;
  }, [items, sortConfig]);

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  return { sortedItems, sortConfig, handleSort };
};
